// Account
export const GET_ACCOUNT = 'GET_ACCOUNT';

// Auth
export const CHECK_AUTHENTICATION = 'CHECK_AUTHENTICATION';
export const LOGOUT = 'LOGOUT';
export const LOGIN = 'LOGIN';

// benefits
export const SET_LISTS = 'SET_LISTS';
// local
export const UPDATE_LOCALS = 'UPDATE_LOCALS';
export const GET_LOCALS = 'GET_LOCALS';
export const UPDATE_RECOMMENDATIONS = 'UPDATE_RECOMMENDATIONS';



// WEBPACK FOOTER //
// ./src/app/store/mutation-types.js